import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { AnimatableColor } from "../AnimatableColor";
export var Stroke = /*#__PURE__*/function () {
  function Stroke() {
    _classCallCheck(this, Stroke);
    this.width = 0;
  }
  _createClass(Stroke, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      if (data.color !== undefined) {
        this.color = AnimatableColor.create(this.color, data.color);
      }
      if (data.width !== undefined) {
        this.width = data.width;
      }
      if (data.opacity !== undefined) {
        this.opacity = data.opacity;
      }
    }
  }]);
  return Stroke;
}();